import { Stack, Typography } from "@mui/material";
import * as React from "react";

export const StatsCards = (props) => {
  const { data } = props;
  const colors = ["#A04D3D", "#5E7360", "#564845"];
  const image = [
    "/icons/ingredient_ic.png",
    "/icons/recipe_ic.png",
    "/icons/template_ic.png",
  ];
  return (
    <Stack
      sx={{
        flexDirection: "row",
        rowGap: "24px",
        columnGap: "8px",
        flexWrap: "wrap",
        mb: "24px",
      }}
    >
      {data?.map((value, i) => (
        <Stack
          key={i}
          sx={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: colors[i],
            borderRadius: "6px",
            padding: "16px",
            gap: "16px",
            width: "402.67px",
            color: "#fff",
          }}
        >
          <Stack gap="8px">
            <Typography fontWeight={600} fontSize="36px" mt={3}>
              {value?.total}
            </Typography>
            <Typography fontSize="16px" fontWeight={500}>
              {value?.label}
            </Typography>
          </Stack>

          <img
            src={image[i]}
            alt="icon"
            style={{
              alignSelf: "flex-end",
              width: "36px",
              height: "36px",
            }}
          />
        </Stack>
      ))}
    </Stack>
  );
};
